import Notice, { NoticeClass, NoticeType } from './Notice';

export default class Alert extends Notice {
	type = NoticeType.ALERT;
	alertType: NoticeClass; // for snackbars
	timeout = -1;  // (for alerts and -1 means never, else set timeout)
	vertical = false;

	constructor(message: string, alertType: NoticeClass) {
		super();
		this.message = message;
		this.alertType = alertType;
	}

	setTimeout(t: number): this {
		this.timeout = t;
		return this;
	}

	setVertical(b: boolean): this {
		this.vertical = b;
		return this;
	}
}